export interface CVPersonalInfo {
  name: string;
  email: string;
  phone: string;
  address?: string;
  linkedin?: string;
  website?: string;
}

export const extractPersonalInfoFromCV = (cvContent: string): CVPersonalInfo => {
  const normalizedContent = cvContent.toLowerCase();
  
  // Patterns to extract personal information
  const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const phonePattern = /(?:\+33|0)[1-9](?:[.\s-]?\d{2}){4}|(?:\+33|0)[1-9]\d{8}/g;
  const namePattern = /^([A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß][a-zàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+(?:\s+[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß][a-zàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+)*)/m;
  const linkedinPattern = /linkedin\.com\/in\/([a-zA-Z0-9-]+)/g;
  const websitePattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  
  // Extract email
  const emailMatch = cvContent.match(emailPattern);
  const email = emailMatch ? emailMatch[0] : '';
  
  // Extract phone
  const phoneMatch = cvContent.match(phonePattern);
  const phone = phoneMatch ? phoneMatch[0] : '';
  
  // Extract name (first non-empty line that looks like a name)
  const lines = cvContent.split('\n').filter(line => line.trim().length > 0);
  let name = '';
  
  for (const line of lines.slice(0, 5)) { // Search in first 5 lines
    const trimmedLine = line.trim();
    
    // Ignore lines with emails, phones, or special characters
    if (emailPattern.test(trimmedLine) || phonePattern.test(trimmedLine)) continue;
    if (trimmedLine.includes('@') || trimmedLine.includes('http')) continue;
    if (trimmedLine.length < 3 || trimmedLine.length > 50) continue;
    
    // Check if it looks like a name
    const nameMatch = trimmedLine.match(/^([A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß][a-zàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+(?:\s+[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß][a-zàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+)*)/);
    if (nameMatch) {
      name = nameMatch[0];
      break;
    }
    
    // If no exact match, take the first line that seems to be a name
    if (!name && /^[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß]/.test(trimmedLine) && 
        !/\d/.test(trimmedLine) && !trimmedLine.includes('•') && !trimmedLine.includes('=')) {
      name = trimmedLine;
      break;
    }
  }
  
  // Extract LinkedIn
  const linkedinMatch = cvContent.match(linkedinPattern);
  const linkedin = linkedinMatch ? `https://linkedin.com/in/${linkedinMatch[0].split('/').pop()}` : '';
  
  // Extract website
  const websiteMatch = cvContent.match(websitePattern);
  const website = websiteMatch ? websiteMatch[0] : '';
  
  // Extract address (approximate)
  let address = '';
  const addressPatterns = [
    /\d+[,\s]+[^,\n]+[,\s]+\d{5}[,\s]+[^,\n]+/g, // Format: number, street, postal code, city
    /\d{5}[,\s]+[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞß][a-zàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+/g // Postal code + city
  ];
  
  for (const pattern of addressPatterns) {
    const addressMatch = cvContent.match(pattern);
    if (addressMatch) {
      address = addressMatch[0].trim();
      break;
    }
  }
  
  return {
    name: name || '',
    email: email || '',
    phone: phone || '',
    address: address || '',
    linkedin: linkedin || '',
    website: website || ''
  };
};

export const saveExtractedCVInfo = (cvInfo: CVPersonalInfo): void => {
  try {
    // localStorage.setItem('cv_analyzer_personal_info', JSON.stringify(cvInfo));
  } catch (error) {
    console.error('Error saving CV info:', error);
  }
};

export const getStoredCVInfo = (): CVPersonalInfo => {
  try {
    const stored = localStorage.getItem('cv_analyzer_personal_info');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading CV info:', error);
  }
  
  return {
    name: '',
    email: '',
    phone: '',
    address: '',
    linkedin: '',
    website: ''
  };
};

export const clearStoredCVInfo = (): void => {
  try {
    localStorage.removeItem('cv_analyzer_personal_info');
  } catch (error) {
    console.error('Error deleting CV info:', error);
  }
};